import TableManager from './TableManager';
import tableTypes from './constants/tableTypes';
import tableProps from './constants/tableProps';
import styles from './tableManager.module.scss';
export { styles };
export default TableManager;
export var TABLE_TYPES = tableTypes;
export var TABLE_MANAGER_DEFAULT_PROPS = tableProps;